import { Button } from '@packages/shared/src/ui/Button/Button';
import type { HTMLAttributes } from 'react';
import { useIntl } from 'react-intl';
import { useAPlusTracking } from '../../hooks/useAPlusTracking/useAPlusTracking';

const Content = ({ onClick, type }: Omit<InfoProps, 'trackingData'>) => {
  const { formatMessage } = useIntl();

  const text = formatMessage({
    id: 'aplus.info.text',
    defaultMessage: 'Mehr Info',
  });

  if (type === 'text') {
    return (
      <Button variant="textLink" onClick={onClick} aria-haspopup="dialog">
        {text}
      </Button>
    );
  }

  return (
    <Button
      variant="icon-flat"
      size="small"
      onClick={onClick}
      aria-label={text}
      aria-haspopup="dialog"
    >
      <span className="icon-emp-information-circle-filled" role="img" />
    </Button>
  );
};

const WithTracking = ({ onClick, trackingData, type }: InfoProps) => {
  const { trackInfoButtonClick } = useAPlusTracking();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (trackingData) {
      trackInfoButtonClick(trackingData);
    }
    onClick(event);
  };

  return <Content onClick={handleClick} type={type} />;
};

type InfoProps = Required<Pick<HTMLAttributes<HTMLButtonElement>, 'onClick'>> & {
  type: 'icon' | 'text';
  trackingData?: {
    uuid: string;
    name: string | null;
  };
};

/**
 * atom for Aplus - Renders an info trigger
 */
export const Info = ({ type, onClick, trackingData }: InfoProps) =>
  trackingData ? (
    <WithTracking onClick={onClick} trackingData={trackingData} type={type} />
  ) : (
    <Content onClick={onClick} type={type} />
  );
